<template>
    <div class="content-container">
        <div class="content h-auto">
            <div class="container">
                <div class="row">
<!--                <div class="row" v-if="reference">-->

                    <!-- Title -->
                    <div class="col-12">
                        <div class="title">
                            <h1>Repair booking complete</h1>
                        </div>
                    </div>

                    <template v-if="reference">

                        <!-- Booking Details -->
                        <div class="col-12">
                            <div class="card">
                                <div class="card-header">
                                    <h4>{{ locationType }}</h4>
                                </div>
                                <div class="card-body pb-2">
                                    <dl v-if="!bookingIsMailIn">
                                        <dt>Repair location</dt>
                                        <dd>{{ parseAddressToString(booking.address) }}</dd>
                                    </dl>
                                    <dl v-if="!bookingIsMailIn">
                                        <dt>Repair date</dt>
                                        <dd>{{ booking.full_date }}</dd>
                                    </dl>
                                    <dl v-if="!bookingIsDropOff && !bookingIsMailIn">
                                        <dt>Timeslot</dt>
                                        <dd>We will send your 1-hour timeslot the day before your repair date by SMS and email</dd>
                                    </dl>
                                    <dl>
                                        <dt>{{ isApplianceRepair ? "Appliance" : "Devices" }}</dt>
                                        <dd v-for="device in devices" :key="device.key">
                                            {{ device.device.title }}
                                        </dd>
                                    </dl>
                                    <dl>
                                        <dt>Billing address</dt>
                                        <dd>{{ parseAddressToString(booking.billing_address) }}</dd>
                                    </dl>
                                    <dl v-if="!booking.is_promotion_event && (!inWarrantyStatus || warrantyRepairChargeable)">
                                        <dt>Total</dt>
                                        <dd><span v-html='currencySymbol'></span>{{ orderTotal }}</dd>
                                    </dl>
                                    <dl v-if="booking.is_promotion_event">
                                        <dt>Promotional Event</dt>
                                        <dd>{{ booking.promotion_event.name }}</dd>
                                    </dl>
                                </div>
                            </div>
                        </div>

                        <!-- IMEI Request -->
                        <div class="col-12" v-if="hasPhoneOrValidTablet && !inWarrantyStatus && !bookingIsMailIn && !isApplianceRepair">
                            <div class="card">
                                <div class="card-header">
                                    <h4>Provide your IMEI number</h4>
                                </div>
                                <div class="card-body pb-2 pt-0">
                                    <small class="cursor-pointer form-text text-underline mb-5" v-b-modal.imei-modal>Where do I find this?</small>
                                    <imei-item
                                        v-for="(device, key) in devices"
                                        :key="key"
                                        :device="device"
                                    ></imei-item>
                                    <div class="alert alert-info mt-4" v-if="carrierDetails.hasCallOutCharge">
                                        <div class="alert-content text-sm">
                                            Supplying your IMEI allows us to validate the device's model and colour. If you have booked in an incorrect model and do not supply an IMEI, you will be subject to a <strong><span v-html='currencySymbol'></span>{{ carrierDetails.callOutCharge }} call-out fee</strong>. Enter your IMEI now to avoid this charge.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Important Information -->
                        <div class="col-12">
                            <div class="card">
                                <div class="card-header">
                                    <h4>Important - before the repair</h4>
                                </div>
                                <div class="card-body pb-2">
                                    <p>
                                        Check that you’ve booked the correct {{ isApplianceRepair ? "appliance" : "device" }} (see above). If the model and/or colour is different, contact us ASAP.
                                    </p>
                                    <template v-if="!bookingIsDropOff && !bookingIsMailIn">
                                        <p>
                                            Ensure there’s parking for our workshop van, not too far from where you live or work.
                                        </p>
                                        <p>
                                            On the morning of your repair, at 08.00, you’ll receive an email and a text confirming your technician's estimated time of arrival (within one hour).
                                        </p>
                                        <p v-if="carrierDetails.hasCallOutCharge">
                                            A missed appointment will incur a <span v-html='currencySymbol'></span>{{ carrierDetails.callOutCharge }} charge.
                                        </p>
                                    </template>
                                    <p v-if="!bookingIsMailIn">
                                        Your technician will arrive and complete the repair in approximately 45 minutes.
                                    </p>
                                    <p v-if="!isApplianceRepair">
                                        Your device will be returned, repaired and fully tested.
                                    </p>
                                    <p class="text-center">
                                        <button class="btn btn-success btn-lg" @click="startNewBooking">Start a new booking</button>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- Contact -->
                        <div class="col-12">
                            <div class="card">
                                <div class="card-header">
                                    <h4>Contact us</h4>
                                </div>
                                <div class="card-body pb-2">
                                    <p>
                                        Telephone: {{ carrierDetails.phone }}
                                    </p>
                                    <p>
                                        Email: <a :href="`mailto:`+carrierDetails.email">{{ carrierDetails.email }}</a>
                                    </p>
                                    <p>
                                        Web: <a :href="carrierDetails.web" target="_blank">{{ carrierDetails.formattedWeb }}</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>

                <!-- IMEI Instruction Modal -->
                <imei-modal></imei-modal>

            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

    export default {
        name: "BookingComplete",

        mounted() {
            // this.checkCanBeOnPage();
            this.retrieveBooking().then(() => {
                if (this.$gtag !== undefined) {
                    this.$gtag.purchase(this.analyticsEcommerceData)
                }
            });
        },

        computed: {
            ...mapGetters([
                "analyticsEcommerceData",
                "booking",
                "carrierDetails",
                "cartTotal",
                "devices",
                "inWarrantyStatus",
                "parseAddressToString",
                "reference",
                "repairLocationOption",
                "warrantyRepairChargeable",
                "warrantyRepairCharge",
                "bookingIsDropOff",
                "bookingIsMailIn",
                "currencySymbol",
                "isApplianceRepair"
            ]),

            carrierName() {
                if (this.carrierDetails.name === "tesco-mobile") {
                    return "Likewize";
                }

                return this.carrierDetails.formattedName;
            },

            hasPhoneOrValidTablet() {
                if (this.devices.length === 0) {
                    return false;
                }

                let hasPhoneOrValidTablet = false;

                for (let i in this.devices) {
                    if (this.devices[i].device.device_type === "phone") {
                        hasPhoneOrValidTablet = true;
                    }
                    // if (this.devices.device_type === "tablet" && this.devices.device_make === "samsung") {
                    //     hasPhoneOrValidTablet = true;
                    // }
                }
                return hasPhoneOrValidTablet;
            },

            locationType() {
                if (this.bookingIsDropOff) {
                    return "In-store drop-off";
                } else if (this.bookingIsMailIn) {
                    return "Mail-in repair";
                }
                return 'Doorstep repair';
            },

            orderTotal() {
                if (this.warrantyRepairChargeable) {
                    return this.warrantyRepairCharge;
                }
                return this.cartTotal;
            }
        },

        methods: {
            ...mapActions([
                "clearBooking",
                "retrieveBooking"
            ]),

            checkCanBeOnPage() {
                if (this.booking.checkout_status !== "SUCCESS") {
                    this.$router.push({name: 'checkout'});
                }
            },

            startNewBooking() {
                this.clearBooking().then(() => {
                    this.$router.push({name: 'booking'})
                });
            }
        }
    }
</script>

<style scoped>

</style>